import { useMsal } from "@azure/msal-react";
import { getTokensRaw } from "../config/authConfig";
import { useCallback } from "react";

const REACT_APP_API_URL =
  "https://mitarbeiterportal-backend-abc8bubxdpddg3du.westeurope-01.azurewebsites.net/";

async function getCareerInfo(userId, instance, inProgress) {
  const idAndAccessToken = await getTokensRaw(instance, inProgress);

  const response = await fetch(REACT_APP_API_URL + "/api/career/" + userId, {
    method: "GET",
    credentials: "include",
    headers: {
      Authorization: "Bearer " + idAndAccessToken.idToken,
      "X-BTB-Access-Token": idAndAccessToken.accessToken,
      "Content-Type": "application/json",
    },
  });
  if (!response.ok) {
    console.error("Die Karrieredaten können nicht geladen werden.");
    return {};
  }

  const careerInfo = await response.json();

  return careerInfo;
}

async function getAccountInfo(instance, inProgress) {
  const idAndAccessToken = await getTokensRaw(instance, inProgress);
  const response = await fetch("https://graph.microsoft.com/v1.0/me", {
    method: "GET",
    headers: {
      Authorization: `Bearer ${idAndAccessToken.accessToken}`,
    },
  });
  const responseData = await response.json();

  return responseData;
}

async function uploadNewExcelFile(file, instance, inProgress) {
  const idAndAccessToken = await getTokensRaw(instance, inProgress);
  const response = await fetch(REACT_APP_API_URL + "/api/upload/", {
    method: "PUT",
    credentials: "include",
    headers: {
      Authorization: "Bearer " + idAndAccessToken.idToken,
      "X-BTB-Access-Token": idAndAccessToken.accessToken,
    },
    body: file,
  });
  if (!response.ok) {
    console.error("Excel Datei konnte nicht hochgeladen werden.");
    return response.status;
  }

  const careerInfo = await response.json();

  return careerInfo;
}

async function adminJsonInfo(instance, inProgress) {
  const idAndAccessToken = await getTokensRaw(instance, inProgress);
  const response = await fetch(REACT_APP_API_URL + "/api/upload/", {
    method: "GET",
    headers: {
      Authorization: "Bearer " + idAndAccessToken.idToken,
      "Content-Type": "application/json",
    },
  });
  if (!response.ok) {
    console.error("Upload-History konnte nicht geladen werden");
    return {};
  }
  const responseData = await response.json();
  return responseData;
}

export default function useFetching() {
  const { instance, inProgress } = useMsal();
  const fetchCareerCallback = useCallback(
    function (userId) {
      return getCareerInfo(userId, instance, inProgress);
    },
    [instance, inProgress]
  );

  const getAccountInfoCallback = useCallback(
    function () {
      return getAccountInfo(instance, inProgress);
    },
    [instance, inProgress]
  );

  const uploadNewExcelFileCallback = useCallback(
    function (file) {
      return uploadNewExcelFile(file, instance, inProgress);
    },
    [instance, inProgress]
  );

  const adminJsonInfoCallback = useCallback(
    function () {
      return adminJsonInfo(instance, inProgress);
    },
    [instance, inProgress]
  );

  return {
    getCareerInfo: fetchCareerCallback,
    getAccountInfo: getAccountInfoCallback,
    uploadNewExcelFile: uploadNewExcelFileCallback,
    adminJsonInfo: adminJsonInfoCallback,
  };
}
